import axios from "axios";
import { toast } from "react-toastify";
import { BASEURL } from "../constant/api";
import { logout } from "../store/auth/action";

const BACKEND_URL = BASEURL.PORT;

export const requestHandler = async (method, url, data, dispatch) => {
  const token = localStorage.getItem("token");

  let config;
  if (token) {
    config = {
      method,
      url: `${BACKEND_URL}/${url}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data,
    };
  } else {
    config = {
      method,
      url: `${BACKEND_URL}/${url}`,
      data,
    };
  }

  try {
    const response = await axios(config);
    return response?.data;
  } catch (err) {
    if (err.response) {
      if (err.response.status === 401) {
        dispatch(logout());
        if (err.response?.data?.detail) toast.error(err.response.data.detail);
      } else if (err.response.status === 404) {
        // history.push("/404");
      } else {
        toast.error(err.response.data.message);
      }
    } else if (err.request) {
      toast.error("Slow Network Speed. Try Again later.");
    } else {
      toast.error("Oops!! Unusual error occurred");
    }
  }
};
